<template>
  <div class="myflow">
  </div>

  
  

</template>

<script>
// @ is an alias to /src
import Footer from '../../components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Footer
  },
  data(){
    return{
      code:'',
      local:window.location.href,
      data:'',
      form:{
        code:'',

      }
      
    }
  },
  
  created(){
    // this.getCode();
    // console.log(this.$route.query)
    document.title = '登录'
    // this.login()
    // this.test();
    this.getCode();
    

  },
  methods:{
    test(){
      this.$http.post('message')
      .then((res)=>{
        this.data = res.data;
      })
    },
    // login(){
    //   this.$http.post('login')
    //   .then((res)=>{
    //     console.log(res)
    //     localStorage.token=res.data;
    //     console.log(localStorage.token)
    //   })
    // }
    getCode(){
      this.code=this.$route.query.code;
      //var code = getUrlParam('code');// 截取路径中的code，如果没有就去微信授权，如果已经获取到了就直接传code给后台获取openId
      console.log(this.code);
      if (this.code == null || this.code == ''||this.code == "undefined") {
        console.log(3)
        //window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid='+APPID+'&redirect_uri=' + encodeURIComponent(local) + '&response_type=code&scope=snsapi_base&state=#wechat_redirect';
        window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wwdec2a282cd543c92&redirect_uri='+encodeURIComponent(this.local)+'&response_type=code&scope=snsapi_base&state=123#wechat_redirect';
        return false;
      } else {
        this.getToken(); //把code传给后台获取用户信息
        return false;
      }
    },
    getToken(){
      this.form.code = this.code
      this.$http.post('get_token',this.form)
      .then((res)=>{
        // this.data = '222222222';
        console.log(res)
        this.data = res.data.data.token;
        localStorage.token=res.data.data.token;
        this.$cookies.set("token",res.data.data.token,"30D")
        this.$router.go(-2);//返回上一层
      })

    },
    

  }
}
</script>
<style scoped>

.home{
  
  background:  url(/images/home_bg.jpg) repeat-x ;
  

}
.payment{
  margin:0px 10px 100px 10px;
  padding-top:10px;
}
</style>
